import { SerializableObjectSchema } from '../../../../../objects/generic/serialization/serializable-object-schema';
import { CommunicationsRequestName } from '../../../communications-request-name';
import { CommunicationsResponse } from '../../generic/communications-response/communications-response';
import { CommunicationsResponseSchema } from '../../generic/communications-response/communications-response-schema';

import { CommunicationsResponseConferenceEndConstructor } from './communications-response-conference-end-constructor';
import { CommunicationsResponseConferenceEndError } from './communications-response-conference-end-error';
import { CommunicationsResponseConferenceEndSchema } from './communications-response-conference-end-schema';

export class CommunicationsResponseConferenceEnd extends CommunicationsResponse<CommunicationsResponseConferenceEndError> {
  /////////////////////////////////////////////////////////////////////////////
  // Constructor
  /////////////////////////////////////////////////////////////////////////////

  constructor(parameters: CommunicationsResponseConferenceEndConstructor) {
    super({
      ...parameters,
      [CommunicationsResponseSchema.type]: CommunicationsRequestName.conferenceEnd,
    });
  }

  /////////////////////////////////////////////////////////////////////////////
  // Deserialize
  /////////////////////////////////////////////////////////////////////////////

  /**
   * This static function is private, and meant to be called only by
   * SerializableObject, and subclasses
   *
   * @param validationResult
   */
  protected static _deserialize(
    validationResult: import('joi').ValidationResult,
  ): CommunicationsResponseConferenceEnd {
    return new CommunicationsResponseConferenceEnd(super._deserialize(validationResult));
  }

  /////////////////////////////////////////////////////////////////////////////
  // Serialize
  /////////////////////////////////////////////////////////////////////////////

  public serialize() {
    return super.serialize(CommunicationsResponseConferenceEnd.getSchema());
  }

  /////////////////////////////////////////////////////////////////////////////
  // Schema
  /////////////////////////////////////////////////////////////////////////////

  public static getSchema(): SerializableObjectSchema {
    return new CommunicationsResponseConferenceEndSchema();
  }
}
